export default "__VITE_ASSET__C4H0Qy8x__"